import { render, staticRenderFns } from "./pointer.vue?vue&type=template&id=1d4ba4f8&"
import script from "./pointer.vue?vue&type=script&lang=js&"
export * from "./pointer.vue?vue&type=script&lang=js&"
import style0 from "./pointer.vue?vue&type=style&index=0&id=1d4ba4f8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports